import React, {useEffect} from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import {Area} from 'organization/Event/AreasProvider'

export type ExportMenuItemBaseProps = {
  label: string
  ariaLabel: string
  area: Area
  onExport: () => void
  processing: boolean
  errorMessage: string | null
  successMessage: string | null
  setError: (error: string | null) => void
  setSuccess: (success: string | null) => void
}

const ExportMenuItemBase = React.forwardRef<
  HTMLLIElement,
  ExportMenuItemBaseProps
>((props, ref) => {
  const {
    label,
    ariaLabel,
    onExport,
    processing,
    errorMessage,
    successMessage,
    setError,
    setSuccess,
  } = props

  useEffect(() => {
    setError(errorMessage)
    setSuccess(successMessage)
  }, [errorMessage, successMessage, setError, setSuccess])

  return (
    <MenuItem
      disabled={processing}
      onClick={onExport}
      aria-label={ariaLabel}
      ref={ref}
    >
      {label}
    </MenuItem>
  )
})

export default ExportMenuItemBase
